<vb-support-widget
    [open]="open"
    (openChange)="onOpenChange($event)"
    [subjects]="subjects"
    [lot]="lot"
    [presetSubjectKey]="presetSubjectKey"
    [sending]="sending"
    [error]="error"
    [fromLine]="fromLine"
    [phone]="phone"
    [phoneHref]="phoneHref"
    [hours]="callRows"
    callRowSubtitle="Phone number and address"
    (send)="onSend($event)"></vb-support-widget>
